// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import ContactHotel from '../_raw/ui/icon_contact_hotel.svg';
import withIconProps from '../withIconProps';

export default withIconProps(ContactHotel);
